module.exports = __webpack_public_path__ + "static/media/sun-light-autumn-equinox.369115e2.svg";